<template>
  <b-modal v-model="modal" centered no-close-on-esc no-close-on-backdrop>
    <h5 class="modal-title" slot="modal-header">
      <i class="mdi mdi-server"></i> Dispositivo
    </h5>
    <b-form-group label="AET" label-for="aet">
      <b-form-input
        type="text"
        id="aet"
        class="col col-lg-12"
        v-model="valor.aet"
        size="sm"
        autocomplete="off"
        :state="!$v.valor.aet.$error"
      ></b-form-input>
      <b-form-invalid-feedback
        >Este Campo &eacute; requerido.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group label="Endereço" label-for="endereco">
      <b-form-input
        type="text"
        id="endereco"
        class="col col-lg-12"
        v-model="valor.endereco"
        size="sm"
        autocomplete="off"
        :state="!$v.valor.endereco.$error"
      ></b-form-input>
      <b-form-invalid-feedback
        >Este Campo &eacute; requerido.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group label="Porta" label-for="porta">
      <b-form-input
        type="text"
        id="porta"
        class="col col-lg-12"
        v-model="valor.porta"
        size="sm"
        autocomplete="off"
        :state="!$v.valor.porta.$error"
      ></b-form-input>
      <b-form-invalid-feedback
        >Este Campo &eacute; requerido.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group label="Retrieve sem compressão" label-for="ativo">
      <toggle-button v-model="valor.retrieveSemCompressao" />
    </b-form-group>

    <div class="w-100" slot="modal-footer">
      <b-button
        @click="fecharModal"
        variant="default"
        size="sm"
        class="float-left"
        >Cancelar</b-button
      >
      <b-button
        @click="salvar"
        variant="success"
        size="sm"
        class="float-right"
        :disabled="botaoSalvar.disabled"
      >
        <i class="mdi" :class="botaoSalvar.icon"></i>
        {{ botaoSalvar.text }}
      </b-button>
    </div>
  </b-modal>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import ServidorApi from "../../api/servidorApi";

export default {
  name: "dispositivoModal",
  model: {
    prop: "mostrarModal",
    event: "change"
  },
  props: {
    dispositivo: {
      type: Object,
      required: true
    },
    mostrarModal: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      modal: this.mostrarModal,
      valor: this.dispositivo,
      salvando: false
    };
  },
  computed: {
    botaoSalvar() {
      return this.salvando
        ? { disabled: true, icon: "mdi-spin mdi-loading", text: "Salvando..." }
        : { icon: "mdi-check-circle", text: "Salvar Dispositivo" };
    }
  },
  validations: {
    valor: {
      aet: { required },
      endereco: { required },
      porta: { required }
    }
  },
  watch: {
    mostrarModal(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }
      if (newVal) this.$v.$reset();
      this.modal = newVal;
      this.valor = this.dispositivo;
    }
  },
  methods: {
    fecharModal() {
      this.modal = false;
      this.$emit("change", false);
      this.valor = {
        id: "",
        aet: "",
        endereco: "",
        porta: ""
      };
    },
    salvar() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.info("Invalido");
        return;
      }

      this.salvando = true;
      let dispositivo = this.valor;
      ServidorApi.salvarDispositivo(dispositivo)
        .then(resp => {
          this.salvando = false;
          dispositivo.id = resp.data.id;
          this.$emit("salvar", dispositivo);
          this.fecharModal();
        })
        .catch(e => {
          console.log(e);
          this.salvando = false;
        });
    }
  }
};
</script>
<style></style>
